const QUANTUM_METRIC_EVENT_CODES = {
  GENERIC_ERROR: 165,
};

export default QUANTUM_METRIC_EVENT_CODES;
